<template>
  <div class="r-dress-style">
    <div class="common-flex" v-for="(item, index) in list" :key="index" style="padding: 8px 0">
      <div class="title">
        <Tooltip class="tool-tips" :disabled="item.imagePath ? false : true">
          <span><Icon v-if="item.imagePath" type="md-photos" /> {{ item.name}}</span>
          <div slot="content">
            <img :src="item.imagePath" :alt="item.name" style="height: 300px">
          </div>
        </Tooltip>
      </div>
      <div :style="{width:listWidth+'px'}" class="common-flex common-flex-wrap list">
        <div
          class="list-item common-hover"
          :class="item.chooseId == Litem.id?'list-item-choose':''"
          v-for="(Litem, Lindex) in item.details"
          :key="Lindex"
          :title="Litem.name"
          @click="changeStyle(item,Litem)"
        >
          {{ Litem.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "Body Type",
          chooseId: 1,
          list: [
            {
              name: "Normal",
              id: 1,
            },
            {
              name: "Body Forward",
              id: 2,
            },
            {
              name: "Body Backward",
              id: 3,
            },
            {
              name: "Body Backward",
              id: 4,
            },
            {
              name: "Body Backward",
              id: 5,
            },
            {
              name: "Body Backward",
              id: 6,
            },
          ],
        },
        {
          name: "Left Shoulder",
          chooseId: 1,
          list: [
            {
              name: "Normal",
              id: 1,
            },
            {
              name: "Body Forward",
              id: 2,
            },
            {
              name: "Body Backward",
              id: 3,
            },
          ],
        },
        {
          name: "Right Shoulder",
          chooseId: 1,
          list: [
            {
              name: "Normal",
              id: 1,
            },
            {
              name: "Body Forward",
              id: 2,
            },
            {
              name: "Body Backward",
              id: 3,
            },
          ],
        },
        {
          name: "Shoulder Blade",
          chooseId: 1,
          list: [
            {
              name: "Normal",
              id: 1,
            },
            {
              name: "Body Forward",
              id: 2,
            },
            {
              name: "Body Backward",
              id: 3,
            },
          ],
        },
      ],
    };
  },
  watch:{
    styleList:{
      handler(newval,oldval){
        this.list = newval
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    // 修改特体信息
    changeStyle(item,Litem){
      this.$emit('changeStyle',item,Litem)
    },

  },
  props:{
    styleList:Array,
    listWidth:{
      default:860,
      type:Number
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tool-tips{
  /deep/.ivu-tooltip-inner{
    max-width: 100% !important;
  }
}
.r-dress-style {
//   > div {
//     margin-bottom: 25px;
//   }
  .title {
    width: 70px;
    margin-right: 40px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 400;
    text-align: left;
    color: #000000;
    line-height: 16px;
  }
  .list {
    width: 660px;
  }
  .list-item {
    border-bottom: solid 1px;
    width: 100px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #f8f8f8;
    font-size: 12px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #979eaa;
    border-radius: 4px;
    margin-right: 8px;
    margin-bottom: 25px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    padding: 0 5px;
  }
  .list-item-choose{
      background: #0A4DCC;
      color: #fff   ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-dress-style-quick.vue